<template>
    <b-modal @hide="modalClose" ref="displayColorModal" size="sm" hide-backdrop hide-footer hide-header :content-class="flg">
        <div class="btns-wrap">
            <div class="btn-color-circle-wrap" v-for="item in $appConfig.userDisplayColors" :key="item.val">
                <tooltip
                    icon="fa-check"
                    position="position-top"
                    :msg="$t(item.name)"
                    :msgMaxLength="$t(item.name).length"
                    :isDisplayColorBtn="true"
                    :displayColorStyle="{'background-color': item.val, 'border-color': item.val, 'padding': 0}"
                    :hex="item.val"
                    @close="modalClose"
                ></tooltip>
            </div>
        </div>
    </b-modal>
</template>

<script>
import tooltip from '@/components/tooltip.vue'
export default {
  props: {
      flg: String,
  },
  components: {
      tooltip,
  },
  methods: {
    modalOpen() {
        this.$refs.displayColorModal.show()
    },
    modalClose(data) {
        this.$emit('modal-close', data)
        this.$refs.displayColorModal.hide()
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-color-circle-wrap {
    display: inline-block;
    padding: 0.8rem;
}
.btns-wrap {
    padding: 1rem;
}
</style>
